import { useEffect } from 'react';

import { useIsMounted } from './useIsMounted';


function useAbortableEffects(effect, dependencies) {
    const isMounted = useIsMounted();

    useEffect(() => {
        if (isMounted()) {
            effect();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMounted, ...dependencies]);
}

export { useAbortableEffects }